import { render, staticRenderFns } from "./HypotekyStats.vue?vue&type=template&id=367e5ded&scoped=true&"
import script from "./HypotekyStats.vue?vue&type=script&lang=js&"
export * from "./HypotekyStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367e5ded",
  null
  
)

export default component.exports